<template>
  <div class="incoming-tender-list-navigation">
    <div class="incoming-tender-list-navigation_left">
      <IncomingTenderVersionSelector v-if="selectedVersion" />
      <div class="divider" />
      <Switcher
        :value="showChangesFromCustomer"
        :label="$t('Show changes from customer')"
        color="orange"
        @change="switchChangesFromCustomer"
      />
    </div>
    <SavedAlert :saved="!isSaving" class="incoming-tender-saved-alert" />
  </div>
</template>

<script>
  import IncomingTenderVersionSelector from '@/components/incoming-tender/version-selector/IncomingTenderVersionSelector';
  import { mapActions, mapGetters, mapState } from 'vuex';
  import SavedAlert from '@/components/ui/SavedAlert';
  import Switcher from '@/components/ui/Switcher';

  export default {
    name: 'IncomingTenderListNavigation',
    components: {
      Switcher,
      SavedAlert,
      IncomingTenderVersionSelector,
    },
    computed: {
      ...mapState({
        isSaving: (state) => state.incomingTender.isSaving,
        showChangesFromCustomer: (state) => state.incomingTender.showChangesFromCustomer,
      }),
      ...mapGetters('incomingTender', ['selectedVersion']),
    },
    methods: {
      ...mapActions('incomingTender', ['switchChangesFromCustomer', 'setChangesFromCustomer']),
    },
    created() {
      if (this.$route.query.show_changes) {
        this.setChangesFromCustomer(true);
      }
    },
  };
</script>

<style scoped>
  .incoming-tender-saved-alert {
    margin-left: auto;
  }
</style>
